import React, { useCallback } from "react";
import { Button, buttonVariants } from "@/lib/components/ui/button";
import { useWidget } from "@/lib/hooks/use-widget";
import { useStytch } from "@stytch/react";
import { cn } from "@/lib/utils";
import { IconUser } from "@/lib/components/icons/user";
import { IconLogout } from "@/lib/components/icons/logout";

const BottomButtons = () => {
  const { redirectUrl } = useWidget();
  const stytchClient = useStytch();

  const logout = useCallback(async () => {
    try {
      await stytchClient.session.revoke();
      window.location.reload();
    } catch (error) {
      console.error("Error revoking session:", error);
    }
  }, [stytchClient]);

  return (
    <>
      <a
        href={`${redirectUrl}/dashboard`}
        target="_blank"
        className={cn(
          buttonVariants({ variant: "outline", size: "lg" }),
          "text-base font-bold",
        )}
      >
        <IconUser className="h-4 w-4" />
        Manage account
      </a>
      <Button variant="outline" size="lg" onClick={() => logout()}>
        <IconLogout className="h-4 w-4" />
        <span className="text-base font-bold">Log out</span>
      </Button>
    </>
  );
};

export default BottomButtons;
